import { httpGetAndParse } from '../../utils/fetchService';

export const fetchDuplicateEntities = ({ taxYear, period, consolidationId, selectedFilingGroup }) =>
  httpGetAndParse({
    route: `/api/consolidations/filing-groups/duplicate-entities/${taxYear}/${period}/${consolidationId}/${selectedFilingGroup}`,
  });
